export default __webpack_public_path__ + "static/media/573.1f4c3154.png";